<template>
  <form>
    <div class="b-dialog__top-panel">
      <h2>{{ $t('CONTENT.counterparty.counterpartyType') }}</h2>
      <button
        class="b-btn b-btn_border_none"
        @click.prevent="close"
      >
        <dynamic-icon icon="close" />
      </button>
    </div>
    <div class="b-dialog__form">
      <div class="row mt-5 b-form__row_type_flex-end">
        <div class="col-4">
          <label>{{ $t('CONTENT.counterparty.counterparty_type') }}:</label>
          <cool-select
            v-model="selectedType"
            :isDisabled="mode == 'delete'"
            :list="getCounterpartyTypes()"
            option-value="id"
            option-text="name"
            :placeholder="getType(item)"
          />
        </div>
        <div class="col-4">
          <label>{{ $t('CONTENT.counterparty.date_type_change') }}:</label>
          <datepicker
            v-model="dateChange"
            class="b-datepicker"
            :formatter="datepickerFormat"
          />
        </div>
        <div class="col-4">
          <label>{{ $t('CONTENT.events.event_date') }}:</label>
          <datepicker
            v-model="dateEvent"
            class="b-datepicker"
            :formatter="datepickerFormat"
          />
        </div>
      </div>
      <div
        v-if="error"
        class="b-contract-edit-errors row mt-5"
      >
        <div class="b-contract-edit-errors__icon-wrap p-4">
          <dynamic-icon icon="warning" />
        </div>
        <div class="b-contract-edit-errors__messages">
          <p class="mb-1">
            {{ error }}
          </p>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6 offset-6">
          <div class="b-form__container b-form__container_type_flex b-form__container_type_flex_end">
            <button
              class="b-btn b-btn_type_primary"
              type="button"
              :disabled="!enableSaveBtn"
              @click="saveBtn"
            >
              {{ $t('CONTENT.save') }}
            </button>
            <button
              class="b-btn b-btn_type_empty m-2"
              type="text"
              @click.prevent="cancelBtn"
            >
              {{ $t('CONTENT.cancel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

import datepickerFormat from '@/mixins/datepickerFormat.mixin';
import dateConverter from '@/utils/converters/date.converter';

export default {
  mixins: [datepickerFormat],
  props: {
    item: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'edit'
    }
  },
  data() {
    return {
      selectedType: this.mode == 'delete'? this.item.counterpartyTypeId : null,
      dateChange: null,
      dateEvent: null,
      error: null,
    };
  },
  computed: {
    enableSaveBtn() {
      return (
        this.selectedType !== null
        && this.dateChange !== null
        && this.dateEvent !== null
      );
    },
  },
  methods: {
    formatDate(date) {
      return dateConverter.convertToString(date, 'DD/MM/YYYY');
    },
    getCounterpartyTypes() {
      switch (this.mode) {
        case 'delete':
          return [
            {id: 2, name: this.$t('CONTENT.reportPage.ThirdParty')},
          ];
        default:
          return [
            {id: 1, name: this.$t('CONTENT.reportPage.Vgo')},
            {id: 0, name: this.$t('CONTENT.reportPage.Related')}
          ];
      }
    },
    getType(item) {
      switch (item.counterpartyTypeId) {
        case 1:
          return this.$t('CONTENT.reportPage.Vgo');
        case 0:
          return this.$t('CONTENT.reportPage.Related');
        case 2:
          return this.$t('CONTENT.reportPage.ThirdParty');
      }
    },
    saveBtn() {
      if (this.dateEvent != null) this.item.eventDate = this.formatDate(this.dateEvent);
      if (this.dateChange != null) this.item.changeDate = this.formatDate(this.dateChange);
      if (this.selectedType != null) this.item.counterpartyTypeId = this.selectedType;
      if (this.item.changeDate > this.item.eventDate) {
        this.error = this.$t('CONTENT.settingsPage.DateChangeErrorMessage');
      } else {
        this.error = null;
        this.$emit('counterpartySaved', this.item);
        this.$emit('enableSaveDate');
        this.$emit('close');
      }
    },
    cancelBtn() {
      this.$emit('close');
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>
